import Teams from "components/Teams/Teams";
import React from "react";

const TeamsPage = () => {
  return <Teams />;
};

export default TeamsPage;
